
import { Component, Prop, Vue } from "vue-property-decorator";

declare var $: any;

@Component({
  props: ["optionId", "optionName", "optionValue", "disabled", "selected"],
})
export default class OptionField extends Vue {}
